export default __webpack_public_path__ + "static/media/boltred-250-min.c3e0ec52.png";